const AWS = require("aws-sdk");
const log = require("../../lib/utils/commons").log;
const { getConfig } = require("../../config");

/**
 * Generate temporary credentials for IAM role through AWS STS and
 * add to global variable "tempAWSCredentials"
 */
const getTemporarySessionCredentials = async (IAM_ASSUME_ROLE) => {
  log.debug(
    `Generating temporary credentials for IAM role - ${getConfig(
      "IAM_ASSUME_ROLE"
    )}`
  );
  let params = {
    RoleArn: IAM_ASSUME_ROLE || getConfig("IAM_ASSUME_ROLE"),
    RoleSessionName: "raas-session",
    DurationSeconds: getConfig("AWS_CREDS_SESSION_DURATION_HRS") * 60 * 60 // valid for these many seconds
  };
  const stsClient = new AWS.STS({ region: getConfig("AWS_REGION") });
  const assumeRole = await stsClient.assumeRole(params).promise();
  const accessCredentials = {
    accessKeyId: assumeRole.Credentials.AccessKeyId,
    secretAccessKey: assumeRole.Credentials.SecretAccessKey,
    sessionToken: assumeRole.Credentials.SessionToken
  };
  return accessCredentials;
};

module.exports = { getTemporarySessionCredentials };
